// src/pages/LoginPage.jsx
import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Card,
  CardContent,
  useTheme
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { loginTeacher } from '../api/authApi';

const LoginPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const [email, setEmail] = useState('teacher@example.com');
  const [password, setPassword] = useState('123456');
  const [error, setError] = useState('');

  const handleLogin = async () => {
    setError('');
    try {
      const token = await loginTeacher(email, password);
      if (!token) {
        setError('توکن دریافت نشد!');
        return;
      }

      localStorage.setItem('teacherToken', token);
      localStorage.setItem('teacherEmail', email);

      const res = await fetch('https://education-backend.liara.run/api/auth/me', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!res.ok) {
        setError('دریافت اطلاعات کاربر ناموفق بود!');
        return;
      }

      const data = await res.json();

      if (data.role === 'Teacher' && !data.id) {
        setError('شناسه معلم در پاسخ وجود ندارد!');
        return;
      }

      localStorage.setItem('teacherRole', data.role);
      if (data.role === 'Teacher') {
        localStorage.setItem('teacherId', data.id.toString());
      } else {
        localStorage.removeItem('teacherId');
      }

      console.log('✅ پاسخ /api/auth/me:', data);

      if (data.role === 'Admin') {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      console.error('❌ خطا در ورود:', err);
      setError('ورود ناموفق بود. لطفاً ایمیل و رمز را بررسی کنید.');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: { xs: 'background.default', md: 'background.paper' },
        p: { xs: 2, sm: 3, md: 4 }
      }}
      dir="rtl"
    >
      <Card
        sx={{
          width: { xs: '100%', sm: 560, md: 480 },
          maxWidth: '100%',
          boxShadow: { xs: 0, sm: 2 },
          borderRadius: { xs: 1, sm: 2 },
          overflow: 'visible'
        }}
        elevation={2}
      >
        <CardContent
          sx={{
            px: { xs: 2, sm: 3 },
            py: { xs: 2, sm: 3 },
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 1.25, sm: 1.75 }
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontSize: { xs: '1.15rem', sm: '1.3rem' },
              fontWeight: 700,
              textAlign: 'center'
            }}
          >
            ورود معلم
          </Typography>

          {error && (
            <Alert
              severity="error"
              sx={{
                fontSize: { xs: '0.85rem', sm: '0.95rem' },
                p: { xs: '6px 12px', sm: '8px 14px' }
              }}
            >
              {error}
            </Alert>
          )}

          <TextField
            label="ایمیل"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            autoComplete="username"
            inputProps={{
              'aria-label': 'email'
            }}
            sx={{
              '& .MuiInputBase-root': {
                fontSize: { xs: '0.9rem', sm: '1rem' }
              }
            }}
          />

          <TextField
            label="رمز عبور"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            autoComplete="current-password"
            inputProps={{
              'aria-label': 'password'
            }}
            sx={{
              '& .MuiInputBase-root': {
                fontSize: { xs: '0.9rem', sm: '1rem' }
              }
            }}
          />

          <Button
            variant="contained"
            fullWidth
            onClick={handleLogin}
            sx={{
              mt: 0.5,
              py: { xs: 1, sm: 1.25 },
              fontSize: { xs: '0.95rem', sm: '1rem' },
              borderRadius: 1,
              textTransform: 'none',
              boxShadow: theme.shadows[1],
              '&:hover': { boxShadow: theme.shadows[3] }
            }}
          >
            ورود
          </Button>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 1,
              mt: { xs: 0.5, sm: 1 },
              flexWrap: 'wrap'
            }}
          >
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '0.75rem', sm: '0.85rem' } }}>
             
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '0.75rem', sm: '0.85rem' } }}>
              
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoginPage;